import * as yup from "yup";

export const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .max(100)
    .required("fieldRequired"),
  last_name: yup
    .string()
    .max(50)
    .required("fieldRequired"),
  first_name: yup
    .string()
    .max(50)
    .required("fieldRequired"),
  mobile_number: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired")
          .required("fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
  location: yup.string().required("fieldRequired"),
  privacy_policy: yup.boolean().oneOf([true], "fieldRequired"),
});

export const mobileSchema = yup.object().shape({
  mobile_number: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("fieldRequired")
          .matches(/^[4-9][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired");
      } else if (select[0]?.value === "853") {
        return schema
          .matches(/^[6][0-9]{7}$/, "fieldRequired")
          .length(8, "fieldRequired")
          .required("fieldRequired");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(/^[1][0-9]{10}$/, "fieldRequired")
          .length(11, "fieldRequired")
          .required("fieldRequired");
      }
      return schema;
    })
    .required("fieldRequired"),
});
